"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppProvider = exports.GlobalListeners = exports.GlobalStyle = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const styled_bootstrap_grid_1 = require("styled-bootstrap-grid");
const react_redux_1 = require("react-redux");
const store_1 = require("@/Redux/store");
const Theme_1 = require("@/Theme");
const spa_core_1 = require("@episerver/spa-core");
const react_router_dom_1 = require("react-router-dom");
const header_1 = require("@/Redux/Actions/header");
const footer_1 = require("@/Redux/Actions/footer");
const cart_1 = require("@/Endpoints/cart");
require("react-datepicker/dist/react-datepicker.css");
const user_1 = require("@/Redux/Actions/user");
const initData_1 = require("@/Redux/Actions/initData");
const errorPages_1 = require("@/Redux/Actions/errorPages");
const Utils_1 = require("@/Utils");
const SentryHOC_1 = __importDefault(require("./SentryHOC/SentryHOC"));
const Meta_1 = __importDefault(require("@/Components/Shared/Meta"));
const Hooks_1 = require("@/Hooks");
const TopProgressBar_1 = __importDefault(require("@/Components/UI/TopProgressBar/TopProgressBar"));
const favoriteShiptosModal_1 = require("@/Redux/Actions/favoriteShiptosModal");
const siteSettings_1 = require("@/Redux/Actions/siteSettings");
const Constants_1 = require("@/Constants");
const react_toastify_1 = require("react-toastify");
require("react-toastify/dist/ReactToastify.css");
const palette_1 = require("app/Theme/palette");
const attributes_1 = require("app/Theme/attributes");
const spacing_1 = require("app/Theme/spacing");
exports.GlobalStyle = (0, styled_components_1.createGlobalStyle) `
  * {
    font-family: ${(_b = (_a = Theme_1.theme === null || Theme_1.theme === void 0 ? void 0 : Theme_1.theme.typography) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.primary};
  }

  html {
    height: 100%;
  }

  body {
    height: 100%;
    font-size: ${(_d = (_c = Theme_1.theme === null || Theme_1.theme === void 0 ? void 0 : Theme_1.theme.typography) === null || _c === void 0 ? void 0 : _c.size) === null || _d === void 0 ? void 0 : _d.defaultSize}px;
    margin: 0;

    ::-webkit-scrollbar {
      all: unset;
      width: ${Theme_1.theme.constants.scrollbarWidth.regular}px;
    }

    ::-webkit-scrollbar-button {
      display: block;
      background-color: ButtonFace;
      box-shadow: inset 0 0 0 20px rgba(255, 255, 255, 0.3);
      height: auto;
      width: inherit;
      background-position: center 5px;
      background-size: 9px 7px;
      image-rendering: pixelated;
      background-repeat: no-repeat;
    }

    ::-webkit-scrollbar-button:hover {
      box-shadow: inset 0 0 0 20px rgba(128, 128, 128, 0.5);
    }

    ::-webkit-scrollbar-button:active {
      box-shadow: inset 0 0 0 20px rgba(128, 128, 128, 0.7);
    }

    ::-webkit-scrollbar-button:vertical:start:increment,
    ::-webkit-scrollbar-button:vertical:end:decrement {
      display: none;
    }

    ::-webkit-scrollbar-button:vertical:decrement {
      background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='ButtonText'><polygon points='50,00 0,50 100,50'/></svg>");
    }

    ::-webkit-scrollbar-button:vertical:increment {
      background-position: center 6px;
      background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='ButtonText'><polygon points='0,0 100,0 50,50'/></svg>");
    }

    ::-webkit-scrollbar-thumb {
      background-color: ButtonFace;
      box-shadow: inset 0 0 0 20px rgba(128, 128, 128, 0.3);
      border-left: 2px solid rgba(255, 255, 255, 0.3);
      border-right: 2px solid rgba(255, 255, 255, 0.3);
    }

    ::-webkit-scrollbar-thumb:hover {
      box-shadow: inset 0 0 0 20px rgba(128, 128, 128, 0.5);
    }

    ::-webkit-scrollbar-thumb:active {
      box-shadow: inset 0 0 0 20px rgba(128, 128, 128, 0.7);
    }

    ::-webkit-scrollbar-track {
      background-color: ButtonFace;
      box-shadow: inset 0 0 0 20px rgba(255, 255, 255, 0.3);
    }
  }

  .error-page-h1 {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: ${props => { var _a; return (_a = props.theme) === null || _a === void 0 ? void 0 : _a.typography.weight.bold; }};
    font-size: ${props => { var _a; return (_a = props.theme) === null || _a === void 0 ? void 0 : _a.typography.size.l1; }}px;
    line-height: ${props => { var _a; return (_a = props.theme) === null || _a === void 0 ? void 0 : _a.typography.size.l2; }}px;
    text-align: center;
  }

  .error-page-p {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: ${props => { var _a; return (_a = props.theme) === null || _a === void 0 ? void 0 : _a.typography.weight.light; }};
    line-height: ${props => { var _a; return (_a = props.theme) === null || _a === void 0 ? void 0 : _a.typography.size.m4; }}px;
    text-align: center;
  }

  .error-page-link-as-btn {
    font-weight: ${props => { var _a; return (_a = props.theme) === null || _a === void 0 ? void 0 : _a.typography.weight.medium; }};
    font-size: ${props => { var _a; return (_a = props.theme) === null || _a === void 0 ? void 0 : _a.typography.size.defaultSize; }}px;
    line-height: ${props => { var _a; return (_a = props.theme) === null || _a === void 0 ? void 0 : _a.spacing.s5; }}px;
    font-style: normal;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
    -webkit-transition-property: color, background;
    transition-property: color, background;
    border-radius: ${props => { var _a; return (_a = props.theme) === null || _a === void 0 ? void 0 : _a.spacing.s1; }}px;
    padding: ${props => { var _a; return (_a = props.theme) === null || _a === void 0 ? void 0 : _a.spacing.s3; }}px ${props => { var _a; return (_a = props.theme) === null || _a === void 0 ? void 0 : _a.spacing.s5; }}px;
    -webkit-text-decoration: none;
    text-decoration: none;
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: -ms-inline-flexbox;
    display: inline-flex;
    position: relative;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border: none;
    color: ${props => { var _a; return (_a = props.theme) === null || _a === void 0 ? void 0 : _a.palette.BW_100; }};
    stroke: ${props => { var _a; return (_a = props.theme) === null || _a === void 0 ? void 0 : _a.palette.BW_100; }};
    background: ${props => { var _a; return (_a = props.theme) === null || _a === void 0 ? void 0 : _a.palette.BLUE_100; }};
    outline-offset: 1px;
  }

  .error-page-link-as-btn:hover {
    background: ${props => { var _a; return (_a = props.theme) === null || _a === void 0 ? void 0 : _a.palette.BLUE_GRAY_100; }};
    border-color: transparent;
    color: white;
    cursor: pointer;
  }

  .error-page-centered-col {
    padding-bottom: ${props => { var _a, _b, _c; return (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.spacing) === null || _b === void 0 ? void 0 : _b.m5) !== null && _c !== void 0 ? _c : 40; }}px;
    padding-top: ${props => { var _a, _b, _c; return (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.spacing) === null || _b === void 0 ? void 0 : _b.m5) !== null && _c !== void 0 ? _c : 40; }}px;

    @media (max-width: ${props => { var _a, _b, _c; return (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.breakpoints) === null || _b === void 0 ? void 0 : _b.lg) !== null && _c !== void 0 ? _c : 992; }}px) {
      padding-bottom: ${props => { var _a, _b, _c; return (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.spacing) === null || _b === void 0 ? void 0 : _b.xl1) !== null && _c !== void 0 ? _c : 80; }}px;
      padding-top: ${props => { var _a, _b, _c; return (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.spacing) === null || _b === void 0 ? void 0 : _b.xl1) !== null && _c !== void 0 ? _c : 80; }}px;
    }
    text-align: center;
    margin: auto;
  }

  .error-page-col-width-padding {
    max-width: 440px;
    padding-top: ${props => { var _a; return (_a = props.theme) === null || _a === void 0 ? void 0 : _a.spacing.m1; }}px;
    padding-bottom: ${props => { var _a; return (_a = props.theme) === null || _a === void 0 ? void 0 : _a.spacing.xl1; }}px;
  }

  .error-page-logo {
    object-fit: cover;
    width: ${props => { var _a, _b, _c; return (_c = (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.spacing) === null || _b === void 0 ? void 0 : _b.m5) !== null && _c !== void 0 ? _c : 40; }}px;
    height: auto;
    position: absolute;
    pointer-events: none;
    top: 0;
    left: 0;
  }

  .error-page-image {
    object-fit: cover;
    width: 100%;
    height: 100%;
    position: absolute;
    pointer-events: none;
    top: 0;
    left: 0;
  }

  a {
    color: ${(_e = Theme_1.theme === null || Theme_1.theme === void 0 ? void 0 : Theme_1.theme.palette) === null || _e === void 0 ? void 0 : _e.BLUE_100};
  }

  #epi-page-container {
    height: 100%;
    position: relative;
  }

  .mosey-layout {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  .content {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .pac-container .pac-item {
    padding: ${props => props.theme.spacing.s2}px ${props => props.theme.spacing.s3}px;
  }

  .current-position-tooltip {
    white-space: pre-wrap;
    max-width: ${props => props.theme.constants.blockWidth.xl}px;
  }

  .Toastify__toast-container {
    min-width: auto !important;
    width: auto !important;
    max-width: max-content !important;
  }

  .Toastify__toast {
    cursor: default !important;
  }
`;
const GlobalListeners = props => {
    const { user: { isAuthenticated, axaptaProfile, userProfile } } = (0, react_redux_1.useSelector)((state) => state);
    const isScrollActive = (0, react_redux_1.useSelector)((state) => state.siteSettings.isScrollActive);
    const isMiniCartOpen = (0, react_redux_1.useSelector)((state) => state.cart.isOpen);
    const isFavoriteShiptosModalOpen = (0, react_redux_1.useSelector)((state) => state.favoriteShiptosModal.isFavoriteShiptosModalOpen);
    const location = (0, react_router_dom_1.useLocation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    (0, Hooks_1.useTranslations)();
    (0, Hooks_1.useInitialData)();
    (0, Hooks_1.useExpirationWatcher)();
    (0, Hooks_1.useAppInsights)();
    (0, react_1.useEffect)(() => {
        const initializeUserData = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            const shiptoToProfiles = (_a = axaptaProfile === null || axaptaProfile === void 0 ? void 0 : axaptaProfile.shipToProfiles) !== null && _a !== void 0 ? _a : [];
            const isShiptoAdded = (0, Utils_1.getCookie)(Constants_1.Cookies.IS_SHIPTO_ADDED);
            const isBillingUser = (userProfile === null || userProfile === void 0 ? void 0 : userProfile.customerAddressType) === user_1.addressType.Billing;
            if (isBillingUser && shiptoToProfiles.length > 1 && !isShiptoAdded) {
                dispatch((0, favoriteShiptosModal_1.setIsFavoriteShiptosModalOpen)(true));
            }
            yield (0, cart_1.getCartData)(dispatch);
        });
        if (isAuthenticated) {
            initializeUserData();
        }
    }, [isAuthenticated]);
    (0, react_1.useEffect)(() => {
        dispatch((0, siteSettings_1.setIsScrollActive)(isFavoriteShiptosModalOpen));
    }, [isFavoriteShiptosModalOpen]);
    (0, react_1.useEffect)(() => {
        dispatch((0, siteSettings_1.setIsScrollActive)(isMiniCartOpen));
    }, [isMiniCartOpen]);
    (0, react_1.useEffect)(() => {
        const scrollY = window.scrollY;
        if (isScrollActive) {
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.left = '0';
            document.body.style.right = `${Theme_1.theme.constants.scrollbarWidth.regular}px`;
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';
        }
        else {
            const y = Math.abs(parseInt(document.body.style.top || '0'));
            document.body.style.removeProperty('position');
            document.body.style.removeProperty('top');
            document.body.style.removeProperty('left');
            document.body.style.removeProperty('right');
            document.body.style.removeProperty('width');
            document.body.style.removeProperty('overflow');
            window.scrollTo(0, y);
        }
    }, [isScrollActive]);
    (0, react_1.useEffect)(() => {
        if ((location === null || location === void 0 ? void 0 : location.pathname) && (window === null || window === void 0 ? void 0 : window.location.hostname)) {
            (0, Utils_1.pageViewEvent)(location.pathname, window.location.hostname);
        }
    }, [location.pathname]);
    return react_1.default.createElement(react_1.default.Fragment, null, props.children);
};
exports.GlobalListeners = GlobalListeners;
const HydrateStore = () => {
    const cmsState = (0, spa_core_1.useCmsState)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const initialState = cmsState.initialState;
    const header = (0, Utils_1.objectToCamelCase)(initialState === null || initialState === void 0 ? void 0 : initialState.Header);
    const footer = (0, Utils_1.objectToCamelCase)(initialState === null || initialState === void 0 ? void 0 : initialState.Footer);
    const initialDataSettings = (0, Utils_1.objectToCamelCase)(initialState === null || initialState === void 0 ? void 0 : initialState.Settings);
    const globalSettings = (0, Utils_1.objectToCamelCase)(initialState === null || initialState === void 0 ? void 0 : initialState.GlobalSettings);
    const errorPages = (0, Utils_1.objectToCamelCase)(initialState === null || initialState === void 0 ? void 0 : initialState.ErrorPages);
    const headerData = (0, Utils_1.mapHeaderData)(header);
    const footerData = (0, Utils_1.mapFooterData)(footer);
    (0, react_1.useEffect)(() => {
        if (headerData) {
            dispatch((0, header_1.setHeaderData)(headerData));
        }
    }, [headerData]);
    (0, react_1.useEffect)(() => {
        if (footerData) {
            dispatch((0, footer_1.setFooterData)(footerData));
        }
    }, [footerData]);
    (0, react_1.useEffect)(() => {
        if (!(0, Utils_1.isObjectEmpty)(initialDataSettings)) {
            dispatch((0, initData_1.setInitialData)(Object.assign(Object.assign({}, initialDataSettings), globalSettings)));
        }
    }, [initialDataSettings]);
    (0, react_1.useEffect)(() => {
        if (errorPages) {
            dispatch((0, errorPages_1.setErrorPagesData)(errorPages));
        }
    }, [errorPages]);
    (0, react_1.useEffect)(() => {
        dispatch((0, user_1.fetchUserData)());
    }, []);
    return null;
};
const AppProvider = props => {
    return (react_1.default.createElement(react_redux_1.Provider, { store: store_1.store },
        react_1.default.createElement(styled_components_1.ThemeProvider, { theme: Theme_1.theme },
            react_1.default.createElement(SentryHOC_1.default, null,
                react_1.default.createElement(TopProgressBar_1.default, null),
                react_1.default.createElement(HydrateStore, null),
                react_1.default.createElement(styled_bootstrap_grid_1.BaseCSS, null),
                react_1.default.createElement(exports.GlobalStyle, null),
                react_1.default.createElement(exports.GlobalListeners, null, props.children),
                react_1.default.createElement(Meta_1.default, null)),
            react_1.default.createElement(react_toastify_1.ToastContainer, { position: "top-right", hideProgressBar: true, closeOnClick: true, draggable: true, theme: "light", closeButton: false, icon: {
                    info: react_1.default.createElement(react_toastify_1.Icons.success, { theme: "light", type: "success", fill: palette_1.palette.GREEN_100 })
                }, toastStyle: {
                    padding: spacing_1.spacing.s5,
                    backgroundColor: palette_1.palette.BW_100,
                    color: palette_1.palette.BLUE_100,
                    boxShadow: attributes_1.attributes.boxShadow.regular,
                    borderRadius: attributes_1.attributes.borderRadius.sm
                } }))));
};
exports.AppProvider = AppProvider;
exports.default = exports.AppProvider;
